// extracted by mini-css-extract-plugin
module.exports = {"container":"Sponsors_container__3yOwo"};